const ContentTypes = {
    TYPE_DIALOG: "engDialogContentComponent",
    TYPE_TEXT: "engTextContent",
    TYPE_SET_VARIABLE: "engSetVariableContent",
    TYPE_MOVIE: "engMovieContent",
    TYPE_SMS: "engSMSContent",
    TYPE_VOICEMAIL: "engVoiceMailContent",
    TYPE_EMAIL: "engEMailContent",
    TYPE_EMAIL_DRAFT: "engMCEMailContent",
    TYPE_GIVE_ITEM: "engGiveItem",
    TYPE_PHONECALL: "engPhonecallContent",
    TYPE_IMAGE: "engImageContent",
    TYPE_OVERLAY_IMAGE: "engOverlayImage",
    TYPE_SET_NUMBER: "engSetNumberContent",
    TYPE_AUDIO: "engAudioContent",
    TYPE_DECISION: "engDecisionContent",
    TYPE_KEY_MOMENT_CHOICE: "engKeyMomentChoiceContent2",
    TYPE_CONVERSATION_TOPIC: "engConversationTopicContent",
    TYPE_FEEDBACK: "engFeedbackContent",
    TYPE_MINIGAME: "engMinigameContent",
    TYPE_FILE: "engFile",
    TYPE_NPC: "engNPCContent",
    TYPE_MCBLOCK: "engMCTextBlock",
    TYPE_QUIZ: "engQuizContentComponent",
    TYPE_QUIZANSWER: "engQuizAnswerContent",
    TYPE_QUIZANSWER_IMAGE: "engQuizAnswerImageContent",
    TYPE_QUIZANSWER_SCALE: "engQuizAnswerScaleContent",
    TYPE_QUIZANSWER_SUBMIT: "engQuizAnswerSubmitContent",
    TYPE_VARIABLE_MUTATION_NUMBER: "engVariableMutationNumberContent",
    TYPE_NARRATIVE_EVENT: "engNarrativeEventContent",
    TYPE_OBJECT: "engObjectContent",
    TYPE_MAP_MUTATION: "engMapMutationContent",
    TYPE_TRANSITION: "engTransitionContent",
    TYPE_APPOINTMENT: "engAppointmentContent",
    TYPE_CHANGE_ENTITY_VISIBILITY: "engChangeEntityVisibility",
    TYPE_MEETING_NOTES: "engMeetingNotesContent",
    TYPE_ANALYTICS_EVENT: "engAnalyticsEventContent",
    TYPE_UNLOCK_LOCATION: "engUnlockLocation",
    TYPE_CHAT: "engChatContent",
    TYPE_TASK: "engTaskContent"
};

export default ContentTypes;